// extracted by mini-css-extract-plugin
export default {"SupportText":"SupportText_SupportText__V48aL","SupportLink":"SupportText_SupportLink__8RLty"};